export function makeTableSortable(tableElement) {
  if(Tablesort !== undefined) {
    new Tablesort(tableElement);
  }
  else {
    console.warn('Tablesort is not loaded!')
  }
}
